import { getOpenOrderCount } from "@/api/order";

// several socket events can trigger overlapping requests; only the latest one
// may update the count so a slow, stale response can't overwrite a newer one
let latestRequestId = 0;

const getDefaultState = () => ({
  openOrderCount: 0,
});

const state = () => getDefaultState();

const mutations = {
  SET_OPEN_ORDER_COUNT: (state, count) => {
    state.openOrderCount = count;
  },
};

const actions = {
  async fetchOpenOrderCount({ commit }) {
    const requestId = ++latestRequestId;
    try {
      const { code, data } = await getOpenOrderCount();
      if (code === 200 && requestId === latestRequestId) {
        commit("SET_OPEN_ORDER_COUNT", data ?? 0);
      }
    } catch (err) {
      // background refresh: keep the last known count instead of showing an error
      console.error("Failed to fetch open order count", err);
    }
  },
};

const getters = {
  getOpenOrderCount(state) {
    return state.openOrderCount;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  getDefaultState,
};
